import { Spinner as NSpinner, type SpinnerProps as Props } from '@heroui/react';

export const Spinner = (props: Props) => {
  return <NSpinner className='' {...props} />;
};
